import {
  getUser
} from "./chunk-NOYUIKST.mjs";
import {
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/auth/user.ts
import { useQuery } from "@tanstack/react-query";
var useGetUser = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["user", props],
    queryFn: () => getUser(props)
  }, options));
};

export {
  useGetUser
};
//# sourceMappingURL=chunk-ADO6ADI6.mjs.map